var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8H2V12H18V8ZM20 7.49899V12.5004C20 13.3288 19.3284 14 18.5 14H1.5C0.671573 14 0 13.3284 0 12.5V7.5C0 6.67157 0.671573 6 1.5 6H18.5C19.3284 6 20 6.67056 20 7.49899Z",
    fill: "#6B696A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51904 10C6.51904 9.44772 6.96676 9 7.51904 9H7.52904C8.08133 9 8.52904 9.44772 8.52904 10C8.52904 10.5523 8.08133 11 7.52904 11H7.51904C6.96676 11 6.51904 10.5523 6.51904 10Z",
    fill: "#6B696A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50928 10C3.50928 9.44772 3.95699 9 4.50928 9H4.51928C5.07156 9 5.51928 9.44772 5.51928 10C5.51928 10.5523 5.07156 11 4.51928 11H4.50928C3.95699 11 3.50928 10.5523 3.50928 10Z",
    fill: "#6B696A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18H2V22H18V18ZM20 17.499V22.5004C20 23.3288 19.3284 24 18.5 24H1.5C0.671573 24 0 23.3284 0 22.5V17.5C0 16.6716 0.671573 16 1.5 16H18.5C19.3284 16 20 16.6706 20 17.499Z",
    fill: "#6B696A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51904 20C6.51904 19.4477 6.96676 19 7.51904 19H7.52904C8.08133 19 8.52904 19.4477 8.52904 20C8.52904 20.5523 8.08133 21 7.52904 21H7.51904C6.96676 21 6.51904 20.5523 6.51904 20Z",
    fill: "#6B696A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50928 20C3.50928 19.4477 3.95699 19 4.50928 19H4.51928C5.07156 19 5.51928 19.4477 5.51928 20C5.51928 20.5523 5.07156 21 4.51928 21H4.50928C3.95699 21 3.50928 20.5523 3.50928 20Z",
    fill: "#6B696A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4.77751C22.2336 4.5472 20.3971 3.63132 18.9997 2.53784C17.6079 3.62548 15.7676 4.5457 14 4.77722V9.83333C14 11.4765 14.5555 12.6226 15.4185 13.5065C16.2788 14.3875 17.5127 15.0734 19.0143 15.6178C20.502 15.0711 21.7261 14.3862 22.5815 13.5086C23.4445 12.6231 24 11.4765 24 9.83333V4.77751Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 7.12417V5.66667H19.8727V12.3583H18.241V7.12417H17.3335Z",
    fill: "#188DED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7252 17.2833C18.9048 17.3502 19.102 17.3532 19.2835 17.2917C22.7502 16.0833 25.6668 14 25.6668 9.83333V4C25.6668 3.77899 25.579 3.56702 25.4228 3.41074C25.2665 3.25446 25.0545 3.16667 24.8335 3.16667C23.1668 3.16667 21.0918 2.175 19.6335 0.899998C19.457 0.749164 19.2324 0.66629 19.0002 0.66629C18.768 0.66629 18.5434 0.749164 18.3668 0.899998C16.9168 2.16667 14.8335 3.16667 13.1668 3.16667C12.9458 3.16667 12.7339 3.25446 12.5776 3.41074C12.4213 3.56702 12.3335 3.77899 12.3335 4V9.83333C12.3335 14 15.2502 16.0833 18.7252 17.2833ZM18.9999 2.53784C20.3972 3.63132 22.2338 4.54721 24.0002 4.77751V9.83333C24.0002 11.4765 23.4447 12.6231 22.5816 13.5086C21.7262 14.3862 20.5022 15.0711 19.0145 15.6178C17.5129 15.0734 16.279 14.3875 15.4187 13.5065C14.5557 12.6226 14.0002 11.4765 14.0002 9.83333V4.77722C15.7678 4.5457 17.608 3.62548 18.9999 2.53784Z",
    fill: "#188DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsIcon);
export default __webpack_public_path__ + "static/media/assets_icon.c45429f6e61b79b18b0974a564c9ed68.svg";
export { ForwardRef as ReactComponent };